/**
 * Shared `DialogContent` styling for a full-bleed Typeform embed.
 *
 * The close button is pinned to a light chip rather than following the site
 * theme: it sits on top of the form, not on our page, so in dark mode Cadence's
 * `dark:text-white` X vanished against the form's white background. The chip
 * keeps it legible whatever theme either side is using.
 */
export const TYPEFORM_DIALOG_CONTENT_CLASS =
  'top-4 right-4 bottom-4 left-4 h-auto w-auto max-w-none translate-x-0 translate-y-0 gap-0 overflow-hidden rounded-2xl p-0 sm:top-8 sm:right-8 sm:bottom-8 sm:left-8 [&>button]:rounded-full [&>button]:bg-white/85! [&>button]:text-gray-950! [&>button]:shadow-sm [&>button]:ring-1 [&>button]:ring-gray-950/10 [&>button]:backdrop-blur-sm [&>button]:hover:bg-white!';
